import GroupRoleView from "./group-role-view.jsx";

export default GroupRoleView